import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
const SELECTOR = '.block-testimonials';
const SWIPER_INIT_ATTR = 'data-testimonials-init';
const initBlock = (block) => {
    const slider = block.querySelector('.js-testimonials-slider');
    if (!slider || slider.hasAttribute(SWIPER_INIT_ATTR)) {
        return;
    }
    slider.setAttribute(SWIPER_INIT_ATTR, '');
    const prevEl = block.querySelector('.block-testimonials__arrow--prev');
    const nextEl = block.querySelector('.block-testimonials__arrow--next');
    const paginationEl = block.querySelector('.block-testimonials__pagination');
    new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 500,
        centerInsufficientSlides: true,
        centeredSlides: true,
        navigation: {
            prevEl,
            nextEl,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            type: 'progressbar',
        },
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
                centeredSlides: false,
                centeredSlidesBounds: false,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 40,
                centeredSlides: false,
                centeredSlidesBounds: false,
            },
        },
    });
};
const init = () => {
    document.querySelectorAll(SELECTOR).forEach(initBlock);
};
document.addEventListener('DOMContentLoaded', init);
if (window.acf) {
    window.acf.addAction('render_block_preview', init);
}
